import { MatDialogRef, MAT_DIALOG_DATA, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { Component, Inject, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { first } from 'rxjs/operators';
import { UntypedFormGroup, UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';

// Services
import { GeaMesCognitoAuthService } from '@gea-mes/cognito';
import { AdminService } from '../../services/admin.service';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { NgIf } from '@angular/common';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-equipbypass-dialog',
    templateUrl: './equipbypass-dialog.component.html',
    styleUrls: ['./equipbypass-dialog.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, FormsModule, ReactiveFormsModule, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, NgIf, MatFormField, MatInput, CdkTextareaAutosize, MatButton, MatIcon, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatDialogActions]
})
export class EquipbypassDialogComponent implements OnInit {

  adminFlag: boolean;
  adminSub$: Subscription;

  input: EquipBypassType;
  data: any[];

  title:string;

  addFormGroup: UntypedFormGroup;

  displayedObjectColumns: string[] = ['Area', 'Section', 'actions']

  constructor(public dialogRef: MatDialogRef<EquipbypassDialogComponent>,
    private svcAdmin: AdminService,
    private fb: UntypedFormBuilder,
    private geaMesCognito: GeaMesCognitoAuthService,
    @Inject(MAT_DIALOG_DATA) public inData: EquipBypassType) { 
      this.input = inData['objData'];
    }

  ngOnInit(): void {
    this.title = `${this.input.ObjectID}: ${this.input.Description}`
    // Check to see if this user is an admin
    this.adminSub$ = this.geaMesCognito.isUserInRole("Admin").pipe(first()).subscribe( out => { 
      this.adminFlag = out;
      if (this.adminSub$) this.adminSub$.unsubscribe(); // We've got an answer, can unsubscribe now
    });    

    this.getEquipBypassList();

    this.addFormGroup = this.fb.group({
      NewArea: '',
      NewSection: ''
    });
  }

  getEquipBypassList() {
    this.svcAdmin.equipBypassList(this.input.Site, this.input.Environment, this.input.ObjectID).subscribe((
      out => {
          console.debug(out);
          this.data = out.Body;
          this.data.push({"Area": "", "Section": ""})
    }));
  }

  delete(area: String, section:string) {
    if (confirm(`Are you sure to delete Bypass for ${this.input.ObjectID} (Area: ${area}, Section: ${section})?`)) {
      this.svcAdmin.equipBypassDelete(this.input.Site, this.input.Environment, this.input.ObjectID, area, section).subscribe((
        out => {
            console.debug(out);
            this.getEquipBypassList();
      }));    
    }
  }

  add() {
    let NewArea:string = this.addFormGroup.controls.NewArea.value;
    let NewSection:string = this.addFormGroup.controls.NewSection.value;
    if (NewArea.trim() != "" && NewSection.trim() != "") {
      this.svcAdmin.equipBypassAdd(this.input.Site, this.input.Environment, this.input.ObjectID, NewArea, NewSection).subscribe((
        out => {
            console.debug(out);
            this.addFormGroup = this.fb.group({
              NewArea: '',
              NewSection: ''
            });          
            this.getEquipBypassList();
      }));
    }
  }

  close() {
    this.dialogRef.close();
  }

}

export interface EquipBypassType {
  Site: string;
  Environment: string;
  ObjectID: string;
  Description: string;
}